<template>
  <div>
    <v-navigation-drawer v-model="appDrawer" fixed temporary color="black">
      <v-list>
        <v-list-item>
          <v-btn icon @click="onLogo()">
            <span class="white--text headline">P</span>
          </v-btn>
        </v-list-item>
        <v-list-item v-for="(nav, index) in mainNavigation" :key="index" :to="nav.link" color="primary">
          <v-list-item-title class="title">
            {{ nav.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed color="black">
      <!-- app -->
      <v-app-bar-nav-icon
        v-show="$vuetify.breakpoint.smAndDown"
        @click.stop="appDrawer = !appDrawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="pa-0">
        <router-link to="/user-profile-plugin">
          <v-avatar style="cursor: pointer" class="white--text">P</v-avatar>
        </router-link>
      </v-toolbar-title>

      <v-btn
        v-show="$vuetify.breakpoint.mdAndUp"
        v-for="nav in mainNavigation"
        :key="nav.title"
        :to="nav.link"
        text
        rounded
        class="mr-2"
      >
        {{ nav.title }}
      </v-btn>

      <v-spacer />

      <v-btn v-for="(nav, index) in socialIcons" :key="index" rounded icon @click="clickUrl(nav)">
        <v-img max-width="18px" :src="require(`@/assets/icons/${nav.icon}`)" :alt="nav.title" aspect-ratio="1"></v-img>
      </v-btn>

      <v-btn rounded color="primary" @click="getProductPlugin()">Download</v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    appDrawer: null,
    mainNavigation: [
      {title: 'About', link: '/user-profile-plugin/about'},
      {title: 'How to use?', link: '/user-profile-plugin/how-to-use'},
      {title: 'Submit Photo', link: '/user-profile-plugin/submit-photo'},
    ],
    socialIcons: [
      {title: 'Tiwtter', icon: 'twitter-brands.svg', link: 'https://twitter.com/roziits'},
      {
        title: 'Github',
        icon: 'github-brands.svg',
        link: 'https://github.com/janisrozenfelds/user-profile-plugin-adobe-xd',
      },
    ],
  }),
  computed: {
    routeHome() {
      return this.$router.currentRoute.name === 'userProfileHome'
    },
  },
  methods: {
    onLogo() {
      this.appDrawer = !this.appDrawer
      if (this.$router.currentRoute.name !== 'userProfileHome') this.$router.push('/user-profile-plugin')
    },
    clickUrl(nav) {
      window.open(nav.link, '_blank')
    },
    getProductPlugin() {
      this.$store.dispatch('getProductPluginLink')
    },
  },
}
</script>
